require('./RARoboStrategyCards.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @assets
const kualaLumpurIcon = require('../../assets/icons/buildings/KualaLumpur_circle.svg');
const shangaiIcon = require('../../assets/icons/buildings/Shanghai_circle.svg');
const taipeiIcon = require('../../assets/icons/buildings/Taipei_circle.svg');
const newYorkIcon = require('../../assets/icons/buildings/NewYork_circle.svg');
const dubaiIcon = require('../../assets/icons/buildings/Dubai_circle.svg');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAStrategyItem = require('./RARoboStrategyItem/RARoboStrategyItem');

// @constants
const {
    CARD_ONE,
    CARD_TWO,
    CARD_THREE,
    CARD_FOUR,
    CARD_FIVE,
} = require('../../raConstants/index');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;

// @contactCenter
const RAStrategyCardsInfo = require('../contactCenter/RAStrategyCardsInfo/RAStrategyCardsInfo');

class RARoboStrategyCards extends React.Component {
    buildInfo() {
        const infoContact = (
            <FormattedText
                value="raStrategyCards-raStrategyCards_contact"
                className="ra-robo-strategy-cards__info--bold"
            />
        );

        return (
            <FormattedTextWithComponents
                value="raStrategyCards-raStrategyCards_info"
                className="ra-robo-strategy-cards__info"
                injectedComponents={[infoContact]}
            />
        );
    }

    render() {
        const {
            clientName,
            firstCardSelected,
            maxAvailable,
            modifyPlan,
            onStrategyDetailsClick,
            selectedCard,
            selectStrategy,
        } = this.props;

        const riskProfiles = [
            {
                id: CARD_ONE,
                countryImage: kualaLumpurIcon,
                riskType: formatText('raStrategyItem-lowRisk'),
                profileType: formatText(
                    'raStrategyItem-veryConservativeProfile',
                ),
                countryLabel: formatText('raStrategyItem-raStrategyItem_1'),
            },
            {
                id: CARD_TWO,
                countryImage: shangaiIcon,
                riskType: formatText('raStrategyItem-midLowRisk'),
                profileType: formatText('raStrategyItem-conservativeProfile'),
                countryLabel: formatText('raStrategyItem-raStrategyItem_2'),
            },
            {
                id: CARD_THREE,
                countryImage: taipeiIcon,
                riskType: formatText('raStrategyItem-midRisk'),
                profileType: formatText('raStrategyItem-moderateProfile'),
                countryLabel: formatText('raStrategyItem-raStrategyItem_3'),
            },
            {
                id: CARD_FOUR,
                countryImage: newYorkIcon,
                riskType: formatText('raStrategyItem-midHighRisk'),
                profileType: formatText('raStrategyItem-dynamicProfile'),
                countryLabel: formatText('raStrategyItem-raStrategyItem_4'),
            },
            {
                id: CARD_FIVE,
                countryImage: dubaiIcon,
                riskType: formatText('raStrategyItem-highRisk'),
                profileType: formatText('raStrategyItem-aggresiveProfile'),
                countryLabel: formatText('raStrategyItem-raStrategyItem_5'),
            },
        ];

        const info = maxAvailable < 5 ? this.buildInfo() : null;

        return (
            <div className="ra-robo-strategy-cards">
                <div className="ra-robo-strategy-cards__items">
                    {riskProfiles.map(
                        ({
                            id,
                            countryImage,
                            riskType,
                            profileType,
                            countryLabel,
                        }) => (
                            <RAStrategyItem
                                key={id}
                                countryImage={countryImage}
                                id={id}
                                riskType={riskType}
                                profileType={profileType}
                                selectedCard={selectedCard}
                                selectStrategy={selectStrategy}
                                disabled={id > maxAvailable}
                                modifyPlan={modifyPlan}
                                firstCardSelected={firstCardSelected}
                                onStrategyDetailsClick={onStrategyDetailsClick}
                                countryLabel={countryLabel}
                            />
                        ),
                    )}
                </div>
                <div className="ra-robo-strategy-cards__info-wrapper">
                    {info}
                </div>
                {__CONTACT_CENTER__ && (
                    <RAStrategyCardsInfo
                        selectedCard={selectedCard}
                        clientName={clientName}
                        suitableProfile={maxAvailable}
                    />
                )}
            </div>
        );
    }
}

RARoboStrategyCards.propTypes = {
    clientName: PropTypes.string,
    firstCardSelected: PropTypes.number,
    maxAvailable: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool,
    onStrategyDetailsClick: PropTypes.func,
    selectedCard: PropTypes.number.isRequired,
    selectStrategy: PropTypes.func.isRequired,
    title: PropTypes.string,
};

RARoboStrategyCards.defaultProps = {
    firstCardSelected: 0,
    modifyPlan: false,
    onStrategyDetailsClick: null,
};

module.exports = RARoboStrategyCards;
